import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ButtonWrapper } from '../../../components';
import type { NodePartner as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface PartnerProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const NodePartner: React.FC<PartnerProps> = ({ entity, className }) => {
  // TODO: This component was quickly thrown together so it looks somewhat representable.
  // It is far from finished.

  const classes = classNames('Node', 'NodePartner', className);
  const partner = entity.toJS();
  const title = partner.title[0].value;
  const body = partner.body[0]?.processed;

  const logo = partner.field_media_item[0];
  const link = partner.field_link[0];
  const linkUrl = link?.alias || link?.uri;
  const linkTitle = link?.title;
  const email = partner.field_email_address[0]?.value;
  const telephone = partner.field_telephone[0]?.value;

  return (
    <div className={classes}>
      <Container>
        <div className="row">
          {logo && (
            <div className="col-12 col-md-4 offset-md-1">
              <DynamicMediaItem
                className="NodePartner__hero__image"
                media={logo}
                imageAspectRatio="1_1"
                aboveTheFold
              />
            </div>
          )}
          <div className="col-12 col-md-8 offset-md-1">
            <h1>{title}</h1>

            <WysiwygField html={body} className="body--large" />
            {link && (
              <ButtonWrapper href={linkUrl}>
                {linkTitle}
              </ButtonWrapper>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NodePartner;
